// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {closeModal} from './modal';
import {messageToShowOnBasisOfAction} from '../services/message-selection';
import {postMassLaborRates} from '../../shared/repositories';
import {routerActions} from 'react-router-redux';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const updateLaborRate = (laborRate, actionToTake) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const updatedLaborRate = [
                ...laborRate
            ];

            await postMassLaborRates(updatedLaborRate);

            closeModal()(dispatch);

            const message = messageToShowOnBasisOfAction(actionToTake);

            successAlertBar(translate(message));

            dispatch(routerActions.push('/tcsm/wip'));

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/action-creators/put-labor-rate.js